import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';

import { BaseAuthComponent } from '../../abstract-components/base-auth.component';
import { DialogService } from '~console/app/~shared/services/dialog.service';
import { ToastService } from '~console/app/~shared/services/toast.service';

@Component({
  selector: 'registration-otp-modal',
  standalone: false,
  templateUrl: './registration-otp-modal.component.html',
  styleUrl: './registration-otp-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationOtpModalComponent extends BaseAuthComponent {
  private readonly _toastService = inject(ToastService);
  private readonly _dialogService = inject(DialogService);

  otpData$ = this._authFacade.loginOtpData$;
  loginCurrentUserData$ = this._authFacade.loginCurrentUserData$;
  isLoggingWithOneTimePassword$ = this._authFacade.isLoggingInWithOtp$;

  form = new FormGroup({
    token: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required]
    })
  });

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const token = this.form.value.token;
    if (!token) {
      return;
    }

    this._authFacade
      .loginWithOneTimePassword(token)
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap(() => this.close())
      )
      .subscribe();
  }

  onOtpResend(): void {
    this._authFacade
      .getRegistrationOneTimePassword()
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap(() =>
          this._toastService.open({
            content: 'Un nouveau code a été envoyé sur votre email.',
            type: 'success'
          })
        )
      )
      .subscribe();
  }

  close(): void {
    this._dialogService.closeAll();
  }

  get tokenControl(): AbstractControl<string, string> | null {
    return this.form.get('token');
  }
}
